import { render, staticRenderFns } from "./Resourcing.vue?vue&type=template&id=f148341c&scoped=true&"
import script from "./Resourcing.vue?vue&type=script&lang=js&"
export * from "./Resourcing.vue?vue&type=script&lang=js&"
import style0 from "./Resourcing.vue?vue&type=style&index=0&id=f148341c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f148341c",
  null
  
)

export default component.exports